export default __webpack_public_path__ + "static/media/sm.d048b19e.svg";